// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wLV1","textarea":"styles_textarea__3ezZo"};